// @flow

import { makeApiCall } from '../apiService/apiService';

export const clientAddressServiceActions = {
  FETCH_CLIENT_ADDRESSES: 'FETCH_CLIENT_ADDRESSES',
  ADD_UPDATE_CLIENT_ADDRESS: 'ADD_UPDATE_CLIENT_ADDRESS',
  GET_PREVIOUS_CLIENT_ADDRESSES: 'GET_PREVIOUS_CLIENT_ADDRESSES'
};

export const fetchClientAddressAction = (load: Object) => ({
  type: clientAddressServiceActions.FETCH_CLIENT_ADDRESSES,
  payload: load
});

export const getPreviousClientAddressesAction = (load: Object) => ({
  type: clientAddressServiceActions.GET_PREVIOUS_CLIENT_ADDRESSES,
  payload: load
});

export const addUpdateClientAddressAction = (load: Object) => ({
  type: clientAddressServiceActions.ADD_UPDATE_CLIENT_ADDRESS,
  payload: load
});

export const addUpdateClientAddress = (callObj: Object) => (
  dispatch: Function
) => {
  dispatch(
    addUpdateClientAddressAction({
      loading: true,
      error: null,
      loaded: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'clientAddress',
    method: callObj.id ? 'PUT' : 'POST',
    data: callObj,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          addUpdateClientAddressAction({
            loading: false,
            error: null,
            loaded: true,
            address: res.payload
          })
        );
      } else {
        dispatch(
          addUpdateClientAddressAction({
            loading: false,
            error: res.errorMessage || 'Error in saving client address',
            loaded: true,
            address: null
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        addUpdateClientAddressAction({
          loading: false,
          error: res.errorMessage || 'Error in saving client address',
          loaded: true,
          address: null
        })
      );
    },
    catchCb: res => {
      dispatch(
        addUpdateClientAddressAction({
          loading: false,
          error: (res && res.errorMessage) || 'Error in saving client address',
          loaded: true,
          address: null
        })
      );
    }
  };
  return makeApiCall(requestObj);
};

export const fetchClientAddress = (apiRequestObj: Object, callback = false) => (
  dispatch: Function
) => {
  dispatch(
    fetchClientAddressAction({
      fetching: true,
      fetched: null,
      error: null,
      clientAddressList: null,
      clientId: apiRequestObj.clientId
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'clientAddressV2',
    method: 'POST',
    data: apiRequestObj,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          fetchClientAddressAction({
            fetching: false,
            clientAddressList: res.payload,
            fetched: true,
            error: null,
            clientId: apiRequestObj.clientId
          })
        );
        if (callback) {
          callback();
        }
      } else if (res.status === 'FAILURE') {
        dispatch(
          fetchClientAddressAction({
            fetching: false,
            clientAddressList: null,
            fetched: true,
            clientId: apiRequestObj.clientId,
            error: res.errorMessage || 'Could not fetch client addresses'
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('fetchClientAddress call failed ', res);
      dispatch(
        fetchClientAddressAction({
          fetching: false,
          clientAddressList: null,
          fetched: true,
          clientId: apiRequestObj.clientId,
          error: res.errorMessage || 'Could not fetch client address'
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception in fetchClientAddress call', res);
      dispatch(
        fetchClientAddressAction({
          fetching: false,
          clientAddressList: null,
          fetched: true,
          clientId: apiRequestObj.clientId,
          error: (res && res.errorMessage) || 'Could not fetch client addresses'
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getPreviousClientAddresses = clientCode => (
  dispatch: Function
) => {
  dispatch(
    getPreviousClientAddressesAction({
      previousAddressList: []
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getPreviousAddresses',
    replaceParamsArr: [
      { key: 'pageNumber', val: 0 },
      { key: 'pageSize', val: 3 },
      { key: 'clientCode', val: clientCode }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getPreviousClientAddressesAction({
            previousAddressList: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line
        console.log('Failure to get previous client addresses  ', res);
        dispatch(
          getPreviousClientAddressesAction({
            previousAddressList: []
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to get previous client addresses ', res);
      dispatch(
        getPreviousClientAddressesAction({
          previousAddressList: []
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while getting previous client addresses ', res);
      dispatch(
        getPreviousClientAddressesAction({
          previousAddressList: []
        })
      );
    }
  };
  return makeApiCall(requestObj);
};
